module.exports = {
    ACCESSIBILITY_ROLES: [
        'comment',
        'complementary',
        'list',
        'listitem',
        'main',
        'mark',
        'navigation',
        'region',
        'suggestion',
        'alert',
        'application',
        'article',
        'banner',
        'button',
        'cell',
        'checkbox',
        'contentinfo',
        'dialog',
        'document',
        'feed',
        'figure',
        'form',
        'grid',
        'gridcell',
        'heading',
        'img',
        'listbox',
        'row',
        'rowgroup',
        'search',
        'switch',
        'tab',
        'table',
        'tabpanel',
        'textbox',
        'timer',
        'menubar',
        'menuitemradio',
        'menuitem',
        'menuitemcheckbox',
        'link',
    ],
};
